import { apiClient } from "api";

export const getReportSignedUrl = async (key: string, as?: string) =>
	apiClient.post("printer/getSignedUrl", { key, as }).then((res) => res.data);
